import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import type { InstrumentPanel } from 'lib-analytics-types';
import { ampli } from 'lib-shared-tracking';

import { useAnalyticsState } from 'analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';

export type InstrumentPanelTitleProps = {
  /** The instrument panel. */
  panel: InstrumentPanel;
};

export const InstrumentPanelTitle = ({
  panel,
}: InstrumentPanelTitleProps): JSX.Element => {
  const { dashboard } = useAnalyticsState();

  const handleHelperClick = () => {
    ampli.analyticsHelperClicked({
      panel: panel.title,
      dashboard: dashboard.title,
    });
  };

  return (
    <FlexBox alignItems="center" gap="200">
      <Text.Heading variant="heading-3">{panel.title}</Text.Heading>

      <FlexBox
        role="button"
        data-analytics-panel-helper
        data-elevio-allow-propagation
        onClick={handleHelperClick}
      >
        <Icon name="info" />
      </FlexBox>
    </FlexBox>
  );
};
